<template>
  <div>
    <el-dialog
      class="dialog-treaty"
      :visible="visible"
      append-to-body
      width="400px"
    >
      <div class="content">
        <div class="title">
          <img
            src="../../../images/member/remind.png"
            v-if="
              remindType.type && (remindType.type == 1 || remindType.type == 2)
            "
          />
          <img src="../../../images/member/overdue.png" v-else />
          <span v-if="remindType.type && remindType.type == 1">
            您还有{{ remindType.content }}道题未做，确定要交卷吗？
          </span>
          <span v-else-if="remindType.type && remindType.type == 2">
            确定要交卷吗？
          </span>
          <span v-else-if="remindType.type && remindType.type == 3">
            对不起，当前考试已下架，有疑问请联系客服。
          </span>
          <span v-else-if="remindType.type && remindType.type == 4">
            考试已结束，正在提交您的试卷
          </span>
          <span v-else-if="remindType.type && remindType.type == 5">
            考试已过期，无法继续参加，请联系客服了解详情
          </span>
          <span v-else-if="remindType.type && remindType.type == 6">
            考试次数已达上限
          </span>
          <span v-else-if="remindType.type && remindType.type == 7">
            考试未开始
          </span>
          <span v-else-if="remindType.type && remindType.type == 8">
            考试已过期
          </span>
          <span v-else-if="remindType.type && remindType.type == 9">
            公开考试未报名
          </span>
        </div>
      </div>
      <template v-slot:footer>
        <el-button type="primary" @click="onConfirm">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "TestingModal",
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    //type,content
    remindType: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    showModal(value) {
      this.visible = value;
    },
  },
  methods: {
    onConfirm() {
      this.visible = false;
      this.$emit("update:showModal", false);
      this.$emit("confirm");
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-treaty {
  /deep/ .el-dialog__header {
    display: none;
  }
  /deep/ .el-dialog__body {
    padding: 20px 24px 0 24px;
  }
  .content {
    .title {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
      margin-bottom: 6px;
      img {
        width: 18px;
        height: 18px;
        vertical-align: middle;
        margin-right: 9px;
      }
      span {
        vertical-align: middle;
      }
    }
  }
  /deep/ .el-dialog__footer {
    padding: 0 24px 24px 24px;
  }
}
</style>
